<div class="thanku">
    <h1>Thankyou !</h1>
    <p>Will Contact You Shortly</p>
    <div class="download-btn11 d-flex pt-0 justify-content-center "style="font-size;lwd,lw\">
        <button class="new"><a href="https://play.google.com/store/apps/details?id=com.marvellous.mining" target="_blank">Download Our App
          </a></button>
        <!-- <button class="video-btn"><span><img src="../../../assets/images/myimages/solar_play-bold.png" alt=""><a
              class="watch-btn" href="">Watch Video</a></span></button> -->
      </div>
  </div>  